import { FormikProvider, Formik, useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import OCTAutocomplete from "../../component/autocompleteOct"
import LabelRequired from "../../component/LabelRequired";
import TextField from "../../component/TextField";
import { ILogDetail } from "../models/LogModels";
import {
  detailLog
} from "../services/services";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import { CODE, KEY, SELECTION_MODE } from '../../utils/Constant';
import { PROCESS_COLUMNS } from "../constants/Columns";

type Props = {
  handleClose: (isBackHomePage?: boolean) => void;
  rowData: any;
};

const OrganizationDetailDialog = (props: Props) => {
  const { handleClose, rowData } = props;
  const intl = useIntl();
  const [initialValues, setInitialValues] = React.useState<ILogDetail>({
    id: "",
    result: "",
    process: [],
  });
  const formRef = useRef<any>(null);
  const validationSchema = Yup.object({});

  useEffect(() => {
    if (rowData?.id) {
      getDetail(rowData?.id);
    }
  }, [rowData]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const getDetail = async (id: string) => {
    try {
      const res = await detailLog(id);

      if (res?.data?.code === CODE.SUCCESS) {
        var tableData = res?.data?.data?.process?.map((item: any, index: number) => ({
          ...item,
          stt: index + 1,
        }));
        var data = {
          ...res?.data?.data,
          process: tableData,
        };
        formik.setValues(data);
        toast.success(intl.formatMessage({ id: "TOAST.GET.SUCCESS" }));
      } else {
        toast.error(`${res?.data?.message}`);
      }
    } catch (err) {
      toast.error(intl.formatMessage({ id: "TOAST.GET.ERROR" }));
    }
  };

  return (
    <Modal show={true} centered onHide={() => handleClose(false)} size="xl" >
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton className="header-modal">
            <Modal.Title className="text-pri ">Thông tin nhật ký</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col lg={12}>
                <TextField
                  label={<LabelRequired label="Body" />}
                  name={"result"}
                  type={"text"}
                  as="textarea"
                  className="min-h-100px max-h-200px"
                  value={formik?.values?.result}
                  disabled={true}
                />
              </Col>
            </Row>
            <div className=" spaces bg-white mb-0 mt-6">
              <TableCustom<any>
                className="spaces h-calc-vh-320"
                data={formik?.values?.process}
                columns={PROCESS_COLUMNS}
                selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                verticalScroll={true}
              />
            </div>
            <Row>

            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="btn-fill spaces mx-3 min-w-90px btn btn-secondary"
              onClick={() => handleClose(false)}
            >
              Hủy
            </Button>
          </Modal.Footer>
        </Form>
      </FormikProvider>
    </Modal>
  );
};

export default OrganizationDetailDialog;
